import React from 'react';
import {
    Grid,
    TextField, Typography,
} from "@mui/material";

export interface ContentsRangeValue {
    start?: string;
    end?: string;
}

interface ContentsRangeProps {
    label: string;
    value: ContentsRangeValue;
    error?: boolean;
    helperText?: React.ReactNode;
    onChange: (value: ContentsRangeValue) => void;
    disabled?: boolean;
    required?: boolean;
}

export default function ContentsRange(props: ContentsRangeProps): JSX.Element {
    const {
        label,
        value,
        error = false,
        helperText,
        onChange,
        disabled = false,
        required = false
    } = props;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange({
            ...value,
            [event.target.name]: event.target.value,
        });
    }

    const borderColour = error ? "rgb(255, 0, 0, 1.0)" : "rgb(0, 0, 0, 0.42)";

    return (
        <Grid
            container
            sx={{
                border: `solid 1px ${borderColour}`,
                borderRadius: "4px",
                padding: 1,
                minHeight: "130px"
            }}>
            <Grid item xs={12}>
                <Typography
                    variant="subtitle2"
                    sx={{textAlign: "left"}}
                >
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <TextField
                    name="start"
                    variant="standard"
                    sx={{width: "95%", marginRight: 1, marginTop: 1}}
                    size="small"
                    label="Start"
                    disabled={disabled}
                    required={required}
                    value={value.start}
                    onChange={handleChange}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    name="end"
                    variant="standard"
                    sx={{width: "95%", marginTop: 1}}
                    size="small"
                    label="End"
                    disabled={disabled}
                    required={required}
                    value={value.end}
                    onChange={handleChange}
                />
            </Grid>
            {
                error &&
                <Grid item xs={12}>
                    <Typography
                        variant="caption"
                        sx={{textAlign: "left", color: "#ff0000"}}
                    >
                        {helperText}
                    </Typography>
                </Grid>
            }
        </Grid>
    );
}
